<app-facility-reporting-period></app-facility-reporting-period>
<app-facility-beds-grid></app-facility-beds-grid>
<app-facility-beds-editor-action></app-facility-beds-editor-action>
